// extracted by mini-css-extract-plugin
export default {"container":"ProfilePage_container__MCgYx","divider":"ProfilePage_divider__YQhuz"};